export default __webpack_public_path__ + "static/media/login_edit.89672f15.svg";